import PowerBIReport from './PowerBIReport'

export default PowerBIReport
